// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import BaiduMap from 'vue-baidu-map'
import wow from 'wowjs'
import animated from 'animate.css'
import 'wowjs/css/libs/animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/style/index.scss'

// import style
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.prototype.$wow = wow
Vue.use(BootstrapVue)
Vue.use(animated)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'xoumRkbNOIbZKIRhR6QQ5ZUMicUlxHMh'
})

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  document.documentElement.scrollTop = 0
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js